<template>
  <pdf-base :id="String(id)" category="PDF教材" routerName="Home" />
</template>

<script>
import PdfBase from "@/components/PDFBase";
export default {
  components: {
    PdfBase
  },
  props: ["id"]
};
</script>
